module.exports = __webpack_public_path__ + "img/topxjjh_bg.330e282e.png";